class AccountingSftpSSPController extends AbstractSftpController
	@register()
	@inject 'IntegrationService',
		'ACCOUNTING_CATEGORIES',
		'BACKEND_TRANSACTION_CARD_TYPE',
		'TenderTypes'

	integrationId: 'accountingSftpSSP'

	initialize: ->
		do super

		@$scope.paymentAccounts = @IntegrationService.getMappableSftpAccounts()
		@$scope.cardTypes = @BACKEND_TRANSACTION_CARD_TYPE
		@$scope.tenderTypes = @TenderTypes.data
		@$scope.accountingCategories = @ACCOUNTING_CATEGORIES.DATA

		if _.isEmpty @$scope.configuration.tender_types
			@$scope.configuration.tender_types = {}

	runIntegration: (timestampFrom, timestampTo, timeZone, splitByDays) =>
		@$scope.saving = true

		requestBody =
			from: timestampFrom
			to: timestampTo
			time_zone: timeZone
			split_by_days: splitByDays

		@IntegrationRepository
			.run @integrationId, requestBody
			.then =>
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.operation.success'),
					'success'
				)
			.catch (response) =>
				@ToastService.showErrors response, @$filter('translate')(@headerText).toString()
			.finally =>
				@$scope.saving = false

	afterDisconnect: ->
		@$scope.configuration = {}
